import { SettingsCategoryFilterButtonRow } from './SettingsCategoryFilterButtonRow';

interface IServiceGroupButtonRowProps {
    onServiceGroupClick: (serviceGroup: { id: string }) => void;
    selectedServiceGroupName: string;
    serviceGroupNames: string[];
}

export function ServiceGroupButtonRow(props: IServiceGroupButtonRowProps) {
    return (
        <SettingsCategoryFilterButtonRow
            collection={props.serviceGroupNames.map((name) => ({ displayText: name, id: name }))}
            onClick={props.onServiceGroupClick}
            selectedItem={{ id: props.selectedServiceGroupName }}
        />
    );
}
